// Generated by Melange

import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as JsxRuntime from "react/jsx-runtime";

function CompTabs$Tab(Props) {
  let name = Props.name;
  let selected = Props.selected;
  let linkTo = Props.linkTo;
  const c = selected === name ? "is-active" : "";
  return JsxRuntime.jsx("li", {
    children: JsxRuntime.jsx("a", {
      children: name,
      onClick: (function (param) {
        ReasonReactRouter.push(linkTo);
      })
    }),
    className: c
  });
}

const Tab = {
  make: CompTabs$Tab
};

function CompTabs(Props) {
  const url = ReasonReactRouter.useUrl(undefined, undefined);
  const match = url.path;
  let selected;
  if (match) {
    switch (match.hd) {
      case "comp" :
        selected = "Tasks";
        break;
      case "pilots" :
        selected = "Pilots";
        break;
      case "settings" :
        selected = "Settings";
        break;
      default:
        selected = "";
    }
  } else {
    selected = "";
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("ul", {
      children: [
        JsxRuntime.jsx(CompTabs$Tab, {
          name: "Settings",
          selected: selected,
          linkTo: "/settings"
        }),
        JsxRuntime.jsx(CompTabs$Tab, {
          name: "Tasks",
          selected: selected,
          linkTo: "/comp"
        }),
        JsxRuntime.jsx(CompTabs$Tab, {
          name: "Pilots",
          selected: selected,
          linkTo: "/pilots"
        })
      ]
    }),
    className: "tabs"
  });
}

const make = CompTabs;

export {
  Tab,
  make,
}
/* ReasonReactRouter Not a pure module */
